const detail = {
  invoiceInfo: [
    {
      name: 'storageMoveDate',
      text: 'storage.storage_register-date',
      required: true,
      cols: Math.ceil((12 - 3) / 2) - 1,
      component: 'NormalDatePicker'
    },
    {
      name: 'trackingNumber',
      text: 'ship.ship_tracking-number'
    },
    {
      name: 'storageAdjustReason',
      text: 'stock-adjust.stock-adjust_inventory-adjustment-reason',
      required: true,
      component: 'SelectStockAdjustReason'
    },
    {
      name: 'storageAdjustReasonTarget',
      text: 'stock-adjust.stock-adjust_target-require-present'
    }
  ],
  receiverInfo: [
    {
      name: 'fullName',
      text: 'common.input_name'
    },
    {
      name: 'phone',
      text: 'common.input_phone-number',
      component: 'PhoneNumberInput'
    },
    {
      name: 'country',
      text: 'common.input_country',
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectCountry'
    },
    {
      name: 'postalCode',
      text: 'common.input_postal-code',
      cols: Math.ceil((12 - 3) / 2)
    },
    {
      name: 'region',
      text: 'common.input_region',
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectRegion'
    },
    {
      name: 'address1',
      text: 'common.input_address_1'
    },
    {
      name: 'address2',
      text: 'common.input_address_2'
    }
  ]
}

export default { detail }
